import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../common/redux/store';
import { DEFAULT_SEARCH_VALUE, DEFAULT_EXPORT_VALUE } from './constant';
import {
  ICustomerExportParams,
  ICustomerSearchParams,
  ICustomerSearchState,
} from './interface';

const initialState: ICustomerSearchState = {
  searchValue: DEFAULT_SEARCH_VALUE,
  exportValue: DEFAULT_EXPORT_VALUE,
  listIdDelete: [],
  showPopupDelete: false,
  showPopupExport: false,
};

export const listCustomerReducer = createSlice({
  name: 'listCustomer',
  initialState: initialState,
  reducers: {
    setSearchValue(state, action: PayloadAction<ICustomerSearchParams>) {
      state.searchValue = action.payload;
    },
    setExportValue(state, action: PayloadAction<ICustomerExportParams>) {
      state.searchValue = action.payload;
    },
    setListIdDelete(state, action: PayloadAction<number[]>) {
      state.listIdDelete = action.payload;
    },
    setShowPopupDelete(state, action: PayloadAction<boolean>) {
      state.showPopupDelete = action.payload;
    },
    setShowPopupExport(state, action: PayloadAction<boolean>) {
      state.showPopupExport = action.payload;
    },
  },
});

export const {
  setSearchValue,
  setExportValue,
  setListIdDelete,
  setShowPopupDelete,
  setShowPopupExport,
} = listCustomerReducer.actions;

export const searchValue = (state: RootState) => state.listCustomer.searchValue;
export const exportValue = (state: RootState) => state.listCustomer.exportValue;
export const listIdDelete = (state: RootState) => state.listCustomer.listIdDelete;
export const showPopupDelete = (state: RootState) => state.listCustomer.showPopupDelete;
export const showPopupExport = (state: RootState) => state.listCustomer.showPopupExport;

export default listCustomerReducer.reducer;
